import React from 'react'
import Link from 'gatsby-link'

const Menu = () => (

  <div style={{
    background: '#f4f4f4',
    paddingTop: '3px',
  }}>

  <ul style = {{
    listStyle: 'none',
    display: 'flex',
    flexWrap: "wrap",
  }}>
    <li><Link to="/">home</Link></li>
    <li><Link to="/about">docs</Link></li>
    <li><Link to="/services">plugins</Link></li>
    <li><Link to="/blog">blog</Link></li>
  </ul>

  </div>
)

export default Menu
